<template>
  <div class="ma-0" id="project_instance">
    <div class="custom-table-design">
      <el-table
        :data="paginatedData"
        :fit="true"
        height="300"
        class="my-2 width-100-p data-table"
        stripe
        scrollbar-always-on: false
      >
        <el-table-column
          :label="'Instance ID'"
          :prop="'id'"
          :width="$vuetify.display.width <= 800 ? 150 : ''"
          sortable
        />
        <el-table-column
          :label="'Region'"
          :prop="'region'"
          :width="$vuetify.display.width <= 800 ? 150 :  ''"
          sortable
        />
        <el-table-column
          :label="'Charger Type'"
          :prop="'charger_type'"
          :width="$vuetify.display.width <= 800 ? 150 : ''"
          sortable
        />
        <el-table-column
          :label="'AI'"
          :prop="'onsite_renewable'"
          :width="$vuetify.display.width <= 800 ? 150 : ''"
          sortable
          >
          <template #default="scope">
            <svg v-if="
                  scope.row.onsite_renewable.toString().toUpperCase() ==
                    'TRUE' ||
                  scope.row.onsite_renewable.toString().toUpperCase() == 'YES'" 
                  id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
              <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
            </svg>
            <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
              <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
            </svg>
          </template>
        </el-table-column>
        <el-table-column
          :label="'TOD'"
          :prop="'time_of_day'"
          :width="$vuetify.display.width <= 800 ? 150 : ''"
          sortable
        >
          <template #default="scope">
            <svg v-if="scope.row.time_of_day" id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
              <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
            </svg>
            <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
              <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
            </svg>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="5"
          class="d-flex justify-content-start align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
            <el-option label="10" :value="'10'" />
            <el-option label="25" :value="'25'" />
            <el-option label="50" :value="'50'" />
            <el-option label="100" :value="'100'" />
            <el-option label="500" :value="'500'" />
            <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>
        <el-col
          :span="8"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col :span="5" class="d-flex justify-content-end align-items-center">
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>
    <div class="custom-pagination" v-if="$vuetify.display.width < 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="24"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col
          :span="10"
          class="d-flex justify-content-end align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
            <el-option label="10" :value="'10'" />
            <el-option label="25" :value="'25'" />
            <el-option label="50" :value="'50'" />
            <el-option label="100" :value="'100'" />
            <el-option label="500" :value="'500'" />
            <el-option label="1k" :value="'1000'" />
          </el-select>
        </el-col>
        <el-col :span="10" class="d-flex justify-content-start align-items-center">
          <span class="text-white">
            {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
              current_page * perPageCount > total_items
                ? total_items.toLocaleString()
                : (current_page * perPageCount).toLocaleString()
            }}
            of {{ total_items.toLocaleString() }}
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import verraReportTableFromPropMixin from "./verraReportTableFromPropMixin";

export default {
  mixins: [verraReportTableFromPropMixin],
  methods: {
    rounding(row, column) {
      const value = row[column.property];
      const valueToNumber = parseFloat(value);

      return !isNaN(valueToNumber) ? parseFloat(valueToNumber.toFixed(4)) : 0;
    },
  },
};
</script>


